import { Badge } from '../common/Badge'

/** Hot = red, Warm = yellow, Cold = blue */
const styles = {
  Hot: 'bg-red-100 text-red-800 ring-1 ring-red-200/70',
  Warm: 'bg-yellow-100 text-yellow-900 ring-1 ring-yellow-200/70',
  Cold: 'bg-blue-100 text-blue-800 ring-1 ring-blue-200/70',
}

export function PriorityBadge({ priority }) {
  const c = styles[priority] || 'bg-slate-100 text-slate-600'
  return <Badge className={c}>{priority}</Badge>
}
